import { getLocale } from 'locales/utils';

const getUrl = (locale, urls) => {
  const pieces = locale.split('-');
  return urls[locale] || urls[pieces[1]] || urls['US'];
};

const privacyPolicy = {};

privacyPolicy['US'] =
  'https://www.kubotausa.com/privacy-policy/kusa-online-privacy-policy';
privacyPolicy['CA'] = 'https://www.kubota.ca/privacy-policy';
privacyPolicy['en-CA'] = privacyPolicy['CA'];
privacyPolicy['fr-CA'] = 'https://www.kubota.ca/fr/privacy-policy';

export const getPrivacyPolicyUrl = locale => {
  return getUrl(locale, privacyPolicy);
};

const termsAndConditions = {};

termsAndConditions['US'] = 'https://www.kubotausa.com/terms-of-use';
termsAndConditions['CA'] = 'https://kubota.ca/terms-conditions';
termsAndConditions['en-CA'] = termsAndConditions['CA'];
termsAndConditions['fr-CA'] = 'https://kubota.ca/fr/terms-conditions';

export const gettermsAndConditionsUrl = locale => {
  return getUrl(locale, termsAndConditions);
};

const contactUsUrls = {
  US: 'https://kubotaservice.my.site.com/public/contactform',
  CA: 'https://kubota.ca/contact-us',
  'en-CA': 'https://kubota.ca/contact-us',
  'fr-CA': 'https://kubota.ca/fr/contact-us',
};

export const getContactUsUrl = () => {
  const locale = getLocale();
  return getUrl(locale, contactUsUrls);
};

const manageFinancingUrls = {
  US: 'https://www.kubotacreditusa.com/homePrepare.do',
};

export const getManageFinancingUrl = () => {
  const locale = getLocale();
  return getUrl(locale, manageFinancingUrls);
};

const frequentlyAskedQuestionsUrls = {
  US: 'https://support.mykubota.com/',
  CA: 'https://support.mykubota.com/',
  'en-CA': 'https://support.mykubota.com/',
  'fr-CA': 'https://support.mykubota.com/',
};

export const getFrequentlyAskedQuestionsUrl = () => {
  const locale = getLocale();
  return getUrl(locale, frequentlyAskedQuestionsUrls);
};
